import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementWebhookService } from '@core/services/entities/management-webhook.service';
import { ManagementWebhookResponseDto } from '@domain/management-webhook/dtos/management-webhook.response.dto';
import { CreateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/create-management-webhook.request.dto';
import { ListManagementWebhookRequestDto } from '@domain/management-webhook/dtos/list-management-webhook.request.dto';
import { UpdateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/update-management-webhook.request.dto';
import { UpdateStateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/update-state-management-webhook.request.dto';
import { ManagementWebhookRepository } from '@domain/management-webhook/repositories/management-webhook.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementWebhookRepositoryService
  implements ManagementWebhookRepository {
  constructor(private managementWebhookService: ManagementWebhookService) { }
  create(
    request: CreateManagementWebhookRequestDto,
  ): Observable<ApiResponse<ManagementWebhookResponseDto>> {
    return this.managementWebhookService.create(request);
  }
  update(
    request: UpdateManagementWebhookRequestDto,
  ): Observable<ApiResponse<ManagementWebhookResponseDto>> {
    return this.managementWebhookService.update(request);
  }
  updateState(
    request: UpdateStateManagementWebhookRequestDto,
  ): Observable<ApiResponse<ManagementWebhookResponseDto>> {
    return this.managementWebhookService.updateState(request);
  }
  show(request: RefId): Observable<ApiResponse<ManagementWebhookResponseDto>> {
    return this.managementWebhookService.show(request);
  }
  list(
    request: ListManagementWebhookRequestDto,
  ): Observable<ApiResponse<PageableResponse<ManagementWebhookResponseDto>>> {
    return this.managementWebhookService.list(request);
  }
}